import { useState, useEffect } from 'react';
import axios from '../utils/axios';

export interface ConfigurationData {
  trader_id: number;
  start_time: string;
  sleep_time_between_activities: number;
  max_profit: number;
  max_loss: number;
  track_on_telegram: boolean;
  strategy_number: number;
  trader_name: string;
  max_days_to_hold: number;
  starting_investment: number;
  single_stock_investment: number;
  regime_filter_spy_enabled: boolean;
  regime_filter_qqq_enabled: boolean;
  min_market_cap: number;
}

export const useConfiguration = (traderId?: number) => {
  const [configuration, setConfiguration] = useState<ConfigurationData | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchConfiguration = async () => {
      try {
        setLoading(true);
        setError(null);
        
        console.log('Fetching configuration data...');
        
        // Build query parameters
        const params: Record<string, any> = {};
        if (traderId) params.trader_id = traderId;
        
        const response = await axios.get('/configuration', { params });
        
        console.log('Configuration data received:', response.data);
        setConfiguration(response.data);
        
      } catch (err: any) {
        console.error('Error fetching configuration:', err);
        const errorMessage = err.response?.data?.detail || err.message || 'Failed to fetch configuration';
        setError(errorMessage);
      } finally {
        setLoading(false);
      }
    };

    fetchConfiguration();
  }, [traderId]);

  return { configuration, loading, error };
};
